
const link = {
    label: 'Link',
    name: 'link',
    widget: 'object',
    fields: [
        {
            label: 'Name',
            name: 'name',
            widget: 'string',
            default: '',
        },
        {
            label: 'URL',
            name: 'url',
            widget: 'string',
            default: '',
        },
    ],
}


export default {
    label: 'Footer',
    name: 'footer',
    file: 'src/content/components/footer.json',
    format: 'json',
    i18n: true,
    create: false,
    fields: [
        {
            label: 'Branding',
            name: 'branding',
            widget: 'object',
            i18n: true,
            fields: [
                {
                    label: 'Name',
                    name: 'name',
                    widget: 'string',
                    default: '',
                    i18n: true,
                },
                {
                    label: 'Description',
                    name: 'description',
                    widget: 'text',
                    default: '',
                    i18n: true,
                },
            ]

        },
        {
            label: 'Copyright',
            name: 'copyright',
            widget: 'string',
            default: '',
            i18n: true,
        },
        {
            label: 'Links',
            name: 'links',
            widget: 'list',
            i18n: true,
            types: [
                link
            ]
        }, 
        {
            label: 'Social Medias',
            name: 'social_medias',
            widget: 'list',
            i18n: true,
            types: [
                {
                    label: 'Social Media',
                    name: 'social_media',
                    widget: 'object',
                    fields: [
                        {
                            label: 'Platform',
                            name: 'platform',
                            widget: 'select',
                            options: ['facebook', 'X', 'instagram', 'youtube'],
                            default: '',
                            i18n: 'duplicate',

                        },
                        {
                            label: 'URL',
                            name: 'url',
                            widget: 'string',
                            default: '',
                            i18n: true,
                        },
                    ],   
                }
            ]
        }
    ]
};